import Vue from 'vue';

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = o[Symbol.iterator]();
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var localPageData = {
  props: {
    localPageData: {
      type: Object,
      required: false
    }
  },
  computed: {
    pageData: function pageData() {
      return this.localPageData || this.$xp.content.pageData;
    }
  }
};

var entry = {
  mixins: [localPageData],
  props: {
    entryData: {
      type: Object,
      required: true
    }
  }
};

var XpBgImg = Vue.extend({
  name: 'XpBgImg',
  props: {
    tag: {
      type: String,
      required: true
    },
    src: String,
    placeholderSrc: String,
    lazyload: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      currentSrc: '',
      image: null,
      isLoading: !!this.src,
      hasError: false,
      intersectionObserver: null
    };
  },
  watch: {
    src: function src() {
      this.load();
    }
  },
  computed: {
    url: function url() {
      return this.src || undefined;
    },
    style: function style() {
      return {
        backgroundImage: 'url(' + this.currentSrc + ')'
      };
    },
    lowstyle: function lowstyle() {
      return {
        backgroundImage: 'url(' + this.placeholderSrc + ')'
      };
    }
  },
  methods: {
    __onLoad: function __onLoad() {
      this.isLoading = false;
      this.hasError = false;

      this.__updateSrc();

      this.$emit('load', this.currentSrc);
    },
    __onError: function __onError(err) {
      // console.warn(err)
      this.isLoading = false;
      this.hasError = true;
      this.currentSrc = '';
      this.$emit('error', err);
    },
    __updateSrc: function __updateSrc() {
      if (this.image !== undefined && this.isLoading === false) {
        var src = this.image.currentSrc || this.image.src;

        if (this.currentSrc !== src) {
          this.currentSrc = src; // this.$forceUpdate()
        }
      }
    },
    __load: function __load() {
      var _this = this;

      this.hasError = false;

      if (!this.src) {
        this.isLoading = false;
        this.image = undefined;
        this.currentSrc = '';
        return;
      }

      this.isLoading = true;
      var img = new Image();
      this.image = img;
      this.$xp.http.getFileUrl(this.src, undefined, false).then(function (data) {
        if (_this.destroyed === true) {
          return;
        }

        img.src = data; // if we are still rendering same image

        if (_this.image === img) {
          _this.__onLoad(img);
        }
      }).catch(function (error) {
        // if we are still rendering same image
        if (_this.image === img && _this.destroyed !== true) {
          _this.__onError(error);
        }
      });
    },
    __unload: function __unload() {
      this.image = undefined;
      this.currentSrc = '';
    }
  },
  render: function render(createElement) {
    return createElement( // Element with Low-Fi Source
    this.tag, {
      style: this.lowstyle,
      attrs: {
        'data-binary-src': this.placeholderSrc,
        'aria-hidden': true
      }
    }, [createElement( // BG-Element with optimal Source
    'div', {
      style: this.style,
      attrs: {
        'data-binary-src': this.src,
        'aria-hidden': true
      }
    })]);
  },
  beforeMount: function beforeMount() {
    if (this.placeholderSrc !== undefined) {
      var img = new Image();
      img.src = this.placeholderSrc;
    }

    this.isLoading = !(this.lazyload && window.IntersectionObserver);
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.lazyload && window.IntersectionObserver) {
      var options = {
        root: document.querySelector('.c-page-container'),
        rootMargin: '0px',
        threshold: 0
      };
      this.intersectionObserver = new IntersectionObserver(function (entries) {
        if (entries[0].intersectionRatio > 0) {
          _this2.__load();
        }
      }, options);
      this.intersectionObserver.observe(this.$el);
    } else {
      this.__load();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroyed = true;

    if (this.intersectionObserver) {
      this.intersectionObserver.unobserve(this.$el);
      this.intersectionObserver = null;
    }

    this.isLoading && this.$xp.http.cancelRequest(this.src);
    if (this.image) this.image.src = '';
  }
});

var script = {
  mixins: [entry],
  components: {
    XpBgImg: XpBgImg
  },
  computed: {
    isAllIconsEmpty: function isAllIconsEmpty() {
      return this.entryData.MenuItems.every(function (item) {
        return item.Icon.ID === 'xp-space';
      });
    }
  },
  mounted: function mounted() {
    this.$el.addEventListener('touchmove', function (event) {
      event.handled = true;
      /* Is handled by default scroll behavior of browser */
    }, false);
  },
  data: function data() {
    return {
      bNoThumbnails: this.entryData.Json && this.entryData.Json.ShowThumbnails ? !this.entryData.Json.ShowThumbnails : true,
      aMetaTagIcons: {
        stationen: 'xp-map-marker',
        dauer: 'xp-clock-o'
      },
      cType: this.entryData.Json && (this.entryData.Json.Type === 'branch' || this.entryData.Json.Type === 'list') ? 'list' : this.entryData.Json.Type
    };
  },
  methods: {
    getThumbnailWidth: function getThumbnailWidth() {
      var _iterator = _createForOfIteratorHelper(this.$xp.settings.mergedSettings.content.imageResolutions),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var w = _step.value;

          if (this.cType === 'gallery' && w >= 400) {
            return w;
          } else if (this.cType !== 'gallery') {
            return w;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    // Text fuer Vorlesebrowser aufbereitet, damit nicht einzelne Elemente durchlaufen werden muessen. Doppelpunkte fuer Pausen.
    getReadout: function getReadout(item) {
      var cReadOutText = '';
      cReadOutText += item.Title;
      if (item.SubTitle > '') cReadOutText += ':' + item.SubTitle;
      cReadOutText += this.getMetaTagsReadout(item.MetaTags);
      return cReadOutText;
    },
    getMetaTagsReadout: function getMetaTagsReadout(aMetaTags) {
      var cReadOutText = '';

      for (var key in aMetaTags) {
        cReadOutText += ':' + key + ':' + aMetaTags[key];
      }

      return cReadOutText;
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "js-entry o-entry c-menu-entry",
      class: _vm.cType,
      attrs: { role: "navigation" }
    },
    [
      _c(
        "ul",
        { staticClass: "c-menu-entry", attrs: { role: "list" } },
        _vm._l(this.entryData.MenuItems, function(item) {
          return _c(
            "li",
            {
              key: item.id,
              attrs: { role: "listitem", datasavefocus: "true" }
            },
            [
              _c(
                "router-link",
                {
                  staticClass: "c-menu-entry__item",
                  class: { "no-thumbnails": _vm.bNoThumbnails },
                  attrs: { tag: "a", to: "/page/" + item.ID }
                },
                [
                  item.Icon.Type == "binary" && !_vm.bNoThumbnails
                    ? _c("xp-bg-img", {
                        staticClass: "c-menu-entry__item-imagewrapper",
                        class: item.Icon.Type,
                        attrs: {
                          tag: "div",
                          src: _vm.$xp.content.getImageUrl(
                            item.Icon.Image,
                            _vm.getThumbnailWidth()
                          ),
                          placeholderSrc: item.Icon.Image.Thumb
                        }
                      })
                    : item.Icon.Type == "icon" && item.Icon.ID !== "xp-space"
                    ? _c("span", {
                        staticClass: "xp",
                        class: item.Icon.ID,
                        attrs: { "aria-hidden": "true" }
                      })
                    : !_vm.isAllIconsEmpty
                    ? _c("span", {
                        staticClass: "xp xp--large xp-space",
                        attrs: { "aria-hidden": "true" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "c-menu-entry__item-textwrapper",
                      attrs: { "aria-label": _vm.getReadout(item) }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "c-menu-entry__item-text",
                          attrs: { "aria-hidden": "true" }
                        },
                        [_vm._v(_vm._s(item.Title))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "c-menu-entry__item-subtitle",
                          attrs: { "aria-hidden": "true" }
                        },
                        [_vm._v(_vm._s(item.SubTitle))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "c-menu-entry__item-metatags",
                          attrs: { "aria-hidden": "true" }
                        },
                        [
                          _vm._l(item.MetaTags, function(value, index) {
                            return [
                              _c("span", { key: "tag" + index }, [
                                _c("span", {
                                  staticClass: "xp",
                                  class: _vm.aMetaTagIcons[index]
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "c-menu-entry__item-metatag" },
                                  [_vm._v(_vm._s(value))]
                                )
                              ])
                            ]
                          })
                        ],
                        2
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        }),
        0
      )
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
//# sourceMappingURL=MenuEntry.js.map
